// extracted by mini-css-extract-plugin
export var disabled = "_c-a";
export var hierarchyLinkGray = "_c-4";
export var hierarchyLinkUnderline = "_c-3";
export var hierarchyPrimary = "_c-0";
export var hierarchySecondary = "_c-1";
export var hierarchyTertiary = "_c-2";
export var pressed = "_c-6";
export var themeAction = "_c-5";
export var themeDestructive = "_c-8";
export var themeNormal = "_c-7";
export var themeSuccess = "_c-9";